import { defineComponent as n, computed as e } from "vue";
import { useNavigationEventBus as s } from "@ado/acs-standard-library";
const d = n({
  name: "FooterLogo",
  props: {
    config: {
      type: Object,
      required: !0
    }
  },
  setup(t) {
    const r = s(), o = e(() => t.config.sitebrand);
    return {
      logoClass: e(() => {
        switch (o.value?.toLowerCase()) {
          case "rechtsdokumente":
            return "footer-logo footer-rd-logo";
          case "documentsl\xE9gaux":
            return "footer-logo footer-dl-logo";
          case "doculaw":
            return "footer-logo footer-dlaw-logo";
          default:
            return "footer-logo footer-ld-logo";
        }
      }),
      sitebrand: o,
      navigationEventBus: r
    };
  }
});
export {
  d as default
};
//# sourceMappingURL=index17.js.map
